module.exports = __webpack_public_path__ + "static/img/便利性.a9fa05ac.png";